import * as Actions from '../../constant/ActionTypes';

const loadingCameraLifecycleUpdateReducers = (response=false, action) => {
    switch(action.type) {
        case Actions.LOADING_UPDATE_CAMERA_LIFE_CYCLE:           
            return action.payload;

        default :
        return response;
    }
}
export default loadingCameraLifecycleUpdateReducers;